import React from 'react';
import { useObservable } from 'react-use-observable';

import { Col, Row } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';
import affiliateService from 'v2/services/affiliate';

import { Export } from './Export';

const Details = () => {
  const [totalItems] = useObservable(() => affiliateService.getTotalItems(), []);
  const [loading] = useObservable(() => affiliateService.isLoading(), []);

  return (
    <>
      <div
        className='mb-2 text-center sm:mb-4 sm:w-full sm:rounded-sm sm:bg-white sm:shadow-[0_1px_0_0_rgba(0,0,0,0.07)]'
        id='affiliates-details'
      >
        <Row className='rounded-t' align='middle'>
          <Col>
            <div className='px-4 py-2'>
              <span
                id='affiliates-result-button-label'
                data-testid='affiliates-result-label'
                className='text-base font-semibold'
              >
                {totalItems || 0} solicitações
              </span>
            </div>
          </Col>
          <PermissionHide action={'myeduzz:meus-afiliados:editar'}>
            <Col style={{ marginLeft: 'auto' }}>{!loading && <Export />} </Col>
          </PermissionHide>
        </Row>
      </div>
    </>
  );
};

export default Details;
